import {
	API_ERROR,
	GET_USER_PERMISSIONS,
	USER_PERMISSIONS_SUCCESSFUL,
	GET_LOCATIONS,
	LOCATION_LIST_SUCCESSFUL,
	GET_SUB_LOCATIONS,
	SUB_LOCATION_LIST_SUCCESSFUL,
	GET_DEPARTMENT,
	DEPARTMENT_LIST_SUCCESSFUL,
	GET_USER_LOCATIONS,
	USER_LOCATION_LIST_SUCCESSFUL,
	GET_USER_SUB_LOCATIONS,
	USER_SUB_LOCATION_LIST_SUCCESSFUL,
	GET_USER_DEPARTMENT,
	USER_DEPARTMENT_LIST_SUCCESSFUL,
	GET_STATE,
	STATE_LIST_SUCCESSFUL,
	GET_VENDORS,
	VENDORS_LIST_SUCCESSFUL,
	GET_VENDORS2,
	VENDORS2_LIST_SUCCESSFUL,
	GET_SECTION,
	SECTION_LIST_SUCCESSFUL,
	GET_CATEGORY,
	CATEGORY_LIST_SUCCESSFUL,
	GET_TAX,
	TAX_LIST_SUCCESSFUL,
	GET_BASICUNIT,
	BASICUNIT_LIST_SUCCESSFUL,
	GET_MINI_PRODUCT_GROUPS_LIST,
	MINI_PRODUCT_GROUPS_LIST_SUCCESSFUL,
	GET_SUBLOCATIONS2,
	SUBLOCATIONS2_LIST_SUCCESSFUL,
	SUBLOCATIONS2_CHANGE_PARAMS,
	CLEAR_SUBLOCATIONS2_LIST,
	GET_MINI_PRODUCT_LIST,
	MINI_PRODUCT_LIST_SUCCESSFUL,
	CLEAR_VENDORS_LIST,
	SUB_ORDER_LOCATIONS_LIST,
	SUB_ORDER_LOCATION_LIST_SUCCESSFUL,
	MINI_SUB_ORDER_LOCATIONS_LIST,
	MINI_SUB_ORDER_LOCATION_LIST_SUCCESSFUL,
} from "./actionTypes";

const initialState = {
	error_msg: "Sorry! No Data Found.",
	userAccessList: [],
	locationslist: [],
	sublocationslist: [],
	minisublocationslist: [],
	suborderlocationslist: [],
	deparmentslist: [],
	userLocation: [],
	usersubLocation: [],
	userDeparment: [],
	categoryList: [],
	sectionlist: [],
	Taxlist: [],
	statelist: [],
	vendorsLoading: false,
	vendorslist: [],
	vendorParams: {
		page: 1,
		page_size: 10,
		search: "",
		no_of_pages: 0,
	},
	vendorslist2: [],
	BasicUnitlist: [],
	miniPGroupList: [],
	miniProductList: {
		results: [],
		count: 0,
	},
	miniProductParams: {
		page: 1,
		page_size: 10,
		search: "",
		no_of_pages: 0,
	},
	sublocationslist2: [],
	sublocationParamas2: {
		page: 1,
		page_size: 10,
		search: "",
		no_of_pages: 0,
	},
};

const Mini = (state = initialState, action) => {
	switch (action.type) {
		case GET_USER_PERMISSIONS:
			state = {
				...state,
				loading: true,
			};
			break;
		case USER_PERMISSIONS_SUCCESSFUL:
			state = {
				...state,
				userAccessList: action.payload.response.data,
				loading: false,
			};

			break;
		case GET_LOCATIONS:
			state = {
				...state,
				loading: true,
			};
			break;
		case LOCATION_LIST_SUCCESSFUL:
			state = {
				...state,
				locationslist: action.payload.response,
				loading: false,
			};

			break;
		case GET_SUB_LOCATIONS:
			state = {
				...state,
				loading: true,
			};
			break;
		case MINI_SUB_ORDER_LOCATIONS_LIST:
			state = {
				...state,
				loading: true,
			};
			break;
		case MINI_SUB_ORDER_LOCATION_LIST_SUCCESSFUL:
			state = {
				...state,
				minisublocationslist: action.payload.response,
				loading: false,
			};

			break;
		case SUB_ORDER_LOCATIONS_LIST:
			state = {
				...state,
				loading: true,
			};
			break;
		case SUB_LOCATION_LIST_SUCCESSFUL:
			state = {
				...state,
				sublocationslist: action.payload.response,
				loading: false,
			};

			break;
		case SUB_ORDER_LOCATION_LIST_SUCCESSFUL:
			state = {
				...state,
				suborderlocationslist: action.payload.response || [],
				loading: false,
			};

			break;
		case GET_SUBLOCATIONS2:
			state = {
				...state,
				loading: true,
			};
			break;
		case CLEAR_SUBLOCATIONS2_LIST:
			state = {
				...state,
				sublocationslist2: [],
				sublocationParamas2: {
					page: 1,
					page_size: 10,
					search: "",
					no_of_pages: 0,
				},
			};
			break;

		case SUBLOCATIONS2_LIST_SUCCESSFUL:
			var response = action.payload.response;
			console.log(action.payload);
			var list = [];
			if (state.sublocationParamas2?.page == 1) {
				list = response.results;
			} else {
				list = [
					...state.sublocationslist2.results,
					...response.results,
				];
			}
			var noofpages = Math.ceil(
				response.count / state.sublocationParamas2?.page_size
			);
			console.log(state.sublocationParamas2);
			state = {
				...state,
				sublocationslist2: { results: list, count: response.count },
				sublocationParamas2: {
					...state.sublocationParamas2,
					count: response.count,
					no_of_pages: noofpages,
				},
				loading: false,
			};
			break;
		case SUBLOCATIONS2_CHANGE_PARAMS:
			console.log(action.payload);
			state = {
				...state,
				sublocationParamas2: action.payload,
				loading: false,
			};
			break;

		case GET_USER_LOCATIONS:
			state = {
				...state,
				loading: true,
			};
			break;
		case USER_LOCATION_LIST_SUCCESSFUL:
			state = {
				...state,
				userLocation: action.payload.response,
				loading: false,
			};

			break;
		case GET_USER_SUB_LOCATIONS:
			state = {
				...state,
				loading: true,
			};
			break;
		case USER_SUB_LOCATION_LIST_SUCCESSFUL:
			state = {
				...state,
				usersubLocation: action.payload.response,
				loading: false,
			};

			break;
		case GET_DEPARTMENT:
			state = {
				...state,
				loading: true,
			};
			break;
		case DEPARTMENT_LIST_SUCCESSFUL:
			state = {
				...state,
				deparmentslist: action.payload.response,
				loading: false,
			};
			break;
		case GET_USER_DEPARTMENT:
			state = {
				...state,
				loading: true,
			};
			break;
		case USER_DEPARTMENT_LIST_SUCCESSFUL:
			state = {
				...state,
				userDeparment: action.payload.response,
				AlluserDept: action.payload.response,
				loading: false,
			};
			break;
		case GET_STATE:
			state = {
				...state,
				loading: true,
			};
			break;
		case STATE_LIST_SUCCESSFUL:
			state = {
				...state,
				statelist: action.payload.response,
				loading: false,
			};
			break;
		case GET_VENDORS:
			state = {
				...state,
				vendorsLoading: true,
			};
			break;
		case CLEAR_VENDORS_LIST:
			state = {
				...state,
				vendorsLoading: initialState.vendorsLoading,
				vendorParams: initialState.vendorParams,
				vendorslist: initialState.vendorslist,
			};
			break;
		case VENDORS_LIST_SUCCESSFUL:
			var response = action.payload.response;
			var params = action.payload.params;
			console.log(action.payload);
			var list = [];
			if (params?.page == 1) {
				list = response.results;
			} else {
				list = [...state.vendorslist, ...response.results];
			}
			var noofpages = Math.ceil(response.count / params?.page_size);
			console.log(params);
			state = {
				...state,
				vendorslist: list,
				vendorParams: {
					...state.vendorParams,
					...params,
					count: response.count,
					no_of_pages: noofpages,
				},
				vendorsLoading: false,
			};

			break;
		case GET_VENDORS2:
			state = {
				...state,
				loading: true,
			};
			break;
		case VENDORS2_LIST_SUCCESSFUL:
			state = {
				...state,
				vendorslist2: action.payload.response,
				loading: false,
			};
			break;
		case GET_SECTION:
			state = {
				...state,
				loading: true,
			};
			break;
		case SECTION_LIST_SUCCESSFUL:
			state = {
				...state,
				sectionlist: action.payload.response,
				loading: false,
			};
			break;
		case GET_CATEGORY:
			state = {
				...state,
				loading: true,
			};
			break;
		case CATEGORY_LIST_SUCCESSFUL:
			state = {
				...state,
				categoryList: action.payload.response,
				loading: false,
			};
			break;
		case GET_TAX:
			state = {
				...state,
				loading: true,
			};
			break;
		case TAX_LIST_SUCCESSFUL:
			state = {
				...state,
				Taxlist: action.payload.response,
				loading: false,
			};
			break;
		case GET_BASICUNIT:
			state = {
				...state,
				loading: true,
			};
			break;
		case BASICUNIT_LIST_SUCCESSFUL:
			state = {
				...state,
				BasicUnitlist: action.payload.response,
				loading: false,
			};
			break;
		case GET_MINI_PRODUCT_GROUPS_LIST:
			state = {
				...state,
				loading: true,
			};
			break;
		case MINI_PRODUCT_GROUPS_LIST_SUCCESSFUL:
			state = {
				...state,
				miniPGroupList: action.payload.response,
				loading: false,
			};
			break;
		case GET_MINI_PRODUCT_LIST:
			state = {
				...state,
				loading: true,
			};
			break;
		case MINI_PRODUCT_LIST_SUCCESSFUL:
			var response = action.payload.response;
			var params = action.payload.params;
			console.log(action.payload);
			var list = [];
			if (params?.page == 1) {
				list = response.results;
			} else {
				list = [...state.miniProductList.results, ...response.results];
			}
			var noofpages = Math.ceil(response.count / params?.page_size);
			console.log(params);
			state = {
				...state,
				miniProductList: { results: list, count: response.count },
				miniProductParams: {
					...state.miniProductParams,
					...params,
					count: response.count,
					no_of_pages: noofpages,
				},
				loading: false,
			};
			break;

		case API_ERROR:
			state = {
				...state,
				loading: false,
				error_msg: action.payload,
			};
			break;
		default:
			state = { ...state };
			break;
	}
	return state;
};

export default Mini;
